import React from 'react';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      quote: "Aspen Quick Care is the only place I go for medical care. The staff and providers are amazing — they've helped me with everything from thyroid issues to infections. Both offices are efficient, caring, and always prioritize patients who need urgent attention."
    },
    {
      id: 2,
      quote: "I've been here multiple times, and every visit has been a great experience. Every provider is patient, knowledgeable, and kind — one even brought me to tears with their warmth. Highly recommend Aspen Quick Care!"
    },
    {
      id: 3,
      quote: "The team went above and beyond to help me without unnecessary delays or extra charges. They truly care about their patients and make the whole experience easy and compassionate."
    }
  ];

  return (
    <section className="testimonials" id="testimonials">
      <div className="section-header">
          <h2>What Our Patients Say</h2>
          <p className="subtitle" style={{color: "white !important"}}>
            Don't just take our word for it. Here's what our patients have to say about their experience with Aspen Quick Care.
          </p>
        </div>
      <div className="container">
        
        
        <div className="testimonials-grid">
          {testimonials.map((testimonial) => (
            <div className="testimonial-card" key={testimonial.id}>
              <div className="quote-icon">"</div>
              <div className="star-rating">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="star">★</span>
                ))}
              </div>
              <blockquote className="testimonial-text">
                {testimonial.quote}
              </blockquote>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
